import { render } from "./receipt_modal.vue?vue&type=template&id=72676c04&scoped=true"
import script from "./receipt_modal.vue?vue&type=script&lang=js"
export * from "./receipt_modal.vue?vue&type=script&lang=js"

import "./receipt_modal.vue?vue&type=style&index=0&id=72676c04&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72676c04"]])

export default __exports__